import { useMemo, useState } from 'react';
import styled from 'styled-components';

const WrapperTab = styled.div`
  column-gap: 10px;
`;
const ItemTab = styled.div`
  text-align: center;
  width: 100px;
  position: relative;
  cursor: pointer;
`;

const HrLine = styled.div`
  position: absolute;
  height: 3px;
  width: 100%;
  margin-top: 5px;
  curosr: pointer;
  background: ${(props) => (props.$isActive === props.$position ? '#3D5AFE' : 'unset')};
`;

function UseTabs() {
  const [isActive, setIsActive] = useState(0);
  function Render({ list = [] }) {
    const renderTab = useMemo(() => (
      <WrapperTab className="d-flex flex-row">
        {list?.map((v, i) => (
          <ItemTab onClick={() => setIsActive(i)}>
            {v.name}
            <HrLine $isActive={isActive} $position={i} />
          </ItemTab>
        ))}
      </WrapperTab>
    ), [isActive, list]);
    return <>{renderTab}</>;
  }

  return { isActive, Render };
}

export default UseTabs;
